import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from "../../../../../Images/informationIcon.png";
import { toTitleCase } from '../../../../../handlers';

const ConfigurationToggleItem = ({ item, disabled, boxValue, type, onAmountChange, onToggle, onTooltip }) => {

	const isSpecial = ['teleVisitPaymentAmount', 'eligFutureDays'].includes(item.flag);
	const checked = isSpecial ? parseInt(item.visible, 10) > -1 : item.visible === 'Y';

	return (
		<div className="col-md-4 col-sm-12">
			<div className="switch-container">
				<span className="switch-field-placeholder">
					<span className="configration-text">
						{toTitleCase(item.title)}
						{isSpecial && (
							<input
								type="text"
								maxLength={5}
								value={(item.visible && item.visible !== "N") ? item.visible : boxValue}
								disabled={disabled}
								onChange={e => onAmountChange(e.target.value, item.flag)}
							/>
						)}
					</span>
					<button
						className="bg-transparent border-0 info-tooltip"
						aria-label="More information"
						type='button'
						onClick={() => onTooltip(item.HELP_TEXT)}
					>
						<img src={InfoIcon} alt="Info" />
					</button>

					<label htmlFor={`my_${item.flag}`} className="switch">
						<input
							type="checkbox"
							checked={checked}
							disabled={disabled}
							onChange={() => onToggle(item, type)}
							id={`my_${item.flag}`}
							aria-label={toTitleCase(item.title)}
						/>
						<span className="slider round" />
					</label>
				</span>
			</div>
		</div>
	);
};

ConfigurationToggleItem.propTypes = {
	item: PropTypes.shape({
		flag: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		visible: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		adv_option_seq_num: PropTypes.string,
		HELP_TEXT: PropTypes.string
	}).isRequired,
	type: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	boxValue: PropTypes.shape({
		Visit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		Future: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}),
	onAmountChange: PropTypes.func,
	onToggle: PropTypes.func,
	onTooltip: PropTypes.func
}

// 

ConfigurationToggleItem.defaultProps = {
	disabled: false, boxValue: {}, onToggle: () => { }, onAmountChange: () => { }, onTooltip: () => { }
};

export default ConfigurationToggleItem;
